<div
    class="relative space-y-4 bg-white shadow-lg p-8 border border-gray-600 rounded-lg max-h-[90vh] overflow-y-auto"
>
    @if (cartService.cartItems().length > 0) {
        @if (isRevalidating()) {
            <ngx-skeleton-loader
                class="flex flex-col gap-4 w-96"
                [theme]="{ height: '5rem' }"
                [count]="cartService.cartItems().length"
            ></ngx-skeleton-loader>
        } @else {
            @for (item of cartService.cartItems(); track $index) {
                <app-cart-item class="block" [item]="item"></app-cart-item>
            }
            <div class="-bottom-8 left-0 sticky bg-primary rounded-lg w-full">
                <app-button
                    size="small"
                    variant="secondary"
                    class="block mx-auto py-6 w-fit"
                    (click)="checkoutService.redirectToCheckout()"
                    >{{ "product.goToCheckout" | translate }}
                </app-button>
            </div>
        }
    } @else {
        <p class="text-black text-lg text-center">
            {{ "product.yourCartIsEmpty" | translate }}
        </p>
        <a
            class="block justify-self-center"
            (click)="this.cartService.toggleCart()"
            routerLink="/{{ languageService.getLanguageCode }}/hof/shop"
        >
            <app-button size="small"
                >{{ "footer.toShop" | translate }}
            </app-button>
        </a>
    }
    <button
        class="top-0 right-0 absolute mr-4 pointer-events-auto"
        (click)="this.cartService.toggleCart()"
    >
        <svg
            class="size-6 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    </button>
</div>
